"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
class TokenService {
    constructor(tokenGetter, refreshTokenGetter, refreshTokenMethod) {
        this.tokenGetter = tokenGetter;
        this.refreshTokenGetter = refreshTokenGetter;
        this.refreshTokenMethod = refreshTokenMethod;
        this.refreshPromise = null;
        this.refreshPromisePendingListenersMap = null;
    }
    get() {
        return this.tokenGetter();
    }
    getRefresh() {
        return this.refreshTokenGetter();
    }
    refreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const listenerId = (0, uuid_1.v4)();
            const res = yield this.getRefreshTokenPromise(listenerId);
            this.handleRefreshTokenResolution(listenerId);
            return res;
        });
    }
    getRefreshTokenPromise(listenerId) {
        if (!this.refreshPromisePendingListenersMap) {
            this.refreshPromise = this.refreshTokenMethod();
            this.refreshPromisePendingListenersMap = new Map();
        }
        this.refreshPromisePendingListenersMap.set(listenerId, false);
        return this.refreshPromise;
    }
    handleRefreshTokenResolution(listenerId) {
        var _a;
        (_a = this.refreshPromisePendingListenersMap) === null || _a === void 0 ? void 0 : _a.set(listenerId, true);
        if (!this.refreshPromisePendingListenersMap)
            return;
        if ([...this.refreshPromisePendingListenersMap.values()].every((el) => el)) {
            this.refreshPromise = null;
            this.refreshPromisePendingListenersMap = null;
        }
    }
}
exports.default = TokenService;
